import api from '../../../api'
import { VoohCampaignRealization } from './VoohCampaignRealization/types'
import { store } from '../../../store'
import { voohCampaignRealizationActions } from './VoohCampaignRealization/slice'
import { VoohCampaign } from '../../../types/campaign'
import { NotifierType } from '../../../components/Notifier'
import { TFunction } from 'react-i18next'

export default class VoohCampaignDetailsService {
  static getVoohCampaignHistory = (campaignId: string) => {
    return api.voohCampaign.getVoohCampaignHistory(campaignId)
  }

  static getVoohCampaignPotential = (campaignId: string) => {
    return api.voohCampaign.getVoohCampaignPotential(campaignId)
  }

  static getVoohImpressions(
    campaignId: string,
    voohCampaignRealizationFilters: VoohCampaignRealization['filters'],
    uuid?: string
  ) {
    const { agglomerations, cities, brands, network, creations, media } =
      voohCampaignRealizationFilters
    void store.dispatch(voohCampaignRealizationActions.setChartDataLoading(true))

    if (uuid) {
      return api.voohCampaign
        .getVoohImpressionsPublic(
          uuid,
          agglomerations
            .filter(filterItem => filterItem.selected)
            .map(filterItem => filterItem.value),
          brands.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
          cities.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
          creations.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
          media.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
          network.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value)
        )
        .then(res => {
          if (res.data) {
            const { impressions } = res.data.voohCampaignReportPublic
            void store.dispatch(voohCampaignRealizationActions.setFetchedChartData(true))
            void store.dispatch(
              voohCampaignRealizationActions.setChartData({
                chartData: impressions.values,
                filters: impressions.facets,
              })
            )
          }
        })
        .finally(() => {
          void store.dispatch(voohCampaignRealizationActions.setChartDataLoading(false))
        })
    }

    return api.voohCampaign
      .getVoohImpressions(
        campaignId,
        agglomerations
          .filter(filterItem => filterItem.selected)
          .map(filterItem => filterItem.value),
        brands.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
        cities.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
        creations.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
        media.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value),
        network.filter(filterItem => filterItem.selected).map(filterItem => filterItem.value)
      )
      .then(res => {
        if (res.data) {
          const { voohImpressions } = res.data
          void store.dispatch(voohCampaignRealizationActions.setFetchedChartData(true))
          void store.dispatch(
            voohCampaignRealizationActions.setChartData({
              chartData: voohImpressions.values,
              filters: voohImpressions.facets,
            })
          )
        }
      })
      .finally(() => {
        void store.dispatch(voohCampaignRealizationActions.setChartDataLoading(false))
      })
  }

  static copyVoohCampaign = (
    campaignId: VoohCampaign['id'],
    addNotification: (type: NotifierType, text: string | string[], time?: number) => void,
    t: TFunction
  ): Promise<void> =>
    api.voohCampaign
      .destroyVoohCampaign(campaignId)
      .then(res => {
        if (!res.data) {
          return
        }

        const { success } = res.data.destroyVoohCampaign
        if (success) {
          addNotification(NotifierType.SUCCESS, t('form.campaign.copy.success'))
        }
      })
      .catch(() => void {})

  static fetchVoohCampaignLocationsFile = (
    voohCampaignIdentifier: string | undefined,
    publicView: boolean
  ): Promise<void> => {
    if (publicView && voohCampaignIdentifier) {
      return api.voohCampaign
        .fetchVoohCampaignLocationsFilePublic(voohCampaignIdentifier)
        .then(res => res.data?.voohCampaignLocationsFilePublic.url)
        .then(url => {
          if (!url) {
            return
          }

          window.open(url, '_blank')
        })
        .catch(() => void {})
    }

    if (!voohCampaignIdentifier) {
      return Promise.resolve()
    }

    return api.voohCampaign
      .fetchVoohCampaignLocationsFile(voohCampaignIdentifier)
      .then(res => res.data?.voohCampaignLocationsFile.url)
      .then(url => {
        if (!url) {
          return
        }

        window.open(url, '_blank')
      })
      .catch(() => void {})
  }
}
